var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"board-certification-item p-1 pl-2",class:{ eligible: _vm.isEligible, certified: !_vm.isEligible, selected: _vm.isSelected },on:{"click":_vm.onClick}},[_vm._v("\n  "+_vm._s(_vm.certification.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }